import React from 'react';
import { Link } from 'react-router';
import t from 'tcomb-form';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { EmailRefinement } from '../utils/tcomb-utils';
import {
  isEmail,
  removeOnBoardingStep
} from '../utils';
import {
  loadOrganization,
  loadOrganizationClaim,
  doClaimOrganization,
  doUpdateOnBoardingSteps,
  doSendVerificationEmail
} from '../actions';


const ProfitType = t.enums({
  nonprofit: "Non Profit",
  forprofit: "For Profit"
});

const OrganizationClaimSchema = t.struct({
  email: EmailRefinement,
  title: t.String,
  phone: t.String,
  organization: t.Number,
  profit_type: ProfitType
});

const formOptions = {
  auto: 'none',
  fields: {
    email: {
      error: 'Please provide a valid email address',
      attrs: {
        placeholder: 'Email'
      }
    },
    title: {
      error: 'please enter your title',
      attrs: {
        placeholder: 'work title'
      }
    },
    phone: {
      error: 'please provide a valid mobile number',
      attrs: {
        placeholder: 'work phone number'
      }
    },
    profit_type: {
      error: 'Please select one of the two',
      factory: t.form.Radio,
      label: 'Is your organization'
    },
    organization: {
      type: 'hidden'
    }
  }
};


class OrganizationClaim extends React.Component {
  state = {
    formOptions: formOptions,
    formValue: {}
  }

  constructor(props) {
    super(props);
  }

  isClaimable = (props) => {
    const { auth, organizationClaim, organization } = props;
    const { user } = auth;
    console.info("claim", organizationClaim)
    console.info("user", user)

    if((user && organizationClaim.id) && user.id) {
      // User is logged in, but claim already exists for this organization
      return false;
    }

    if(!organizationClaim.id && (user && user.organizationClaim)) {
      // User is logged in, claim does not exists for this organization
      // but the logged in user has already claimed an organization.
      return false;
    }

    if(organizationClaim.id && !user) {
      // Claim exists but not the user, which usually means anonymous user.
      return false;
    }

    return true;
  };

  getFormState = (formValue = null) => {
    const { auth, organizationClaim, organization  } = this.props;
    let formOptions = Object.assign({}, this.state.formOptions);
    if (!formValue) {
      formValue = Object.assign({}, this.state.formValue);
    }

    if (organization.isLoading || organizationClaim.isLoading || auth.isLoading) {
      return {
        formValue,
        formOptions
      };
    }

    const { user } = auth;

    if (!user) {
      return {
        formValue,
        formOptions
      };
    }


    if (!formValue.email) {
      if(organizationClaim.errors) {
        formValue.email = organizationClaim.errors.email;
      } else {
        formValue.email =  user.email
      }
    }

    formValue.organization = organization.db_id;

    if(organizationClaim.errors) {
      if(organizationClaim.errors.user_errors) {
        formOptions.hasError = true;
        formOptions.fields.email.hasError = true;
        formOptions.fields.email.error = organizationClaim.errors.user_errors.email;
      } else {
        formOptions.hasError = false;
        formOptions.fields.email.hasError = false;
        formOptions.fields.email.error = '';
      }
    }

    const { email } = formValue;
    const domain = this.extractDomain(organization.website);

    if(this.emailDomainMatches(email, domain)) {
      formOptions.hasError = false;
      formOptions.error = '';
    } else {

      // DISABLE EMAIL DOMAIN ORG DOMAIN MATCHING BELOW!
      // UNCOMMENT BELOW TO REINSTATE MATCHING PROTOCAL

      /*
      formOptions.hasError = true;
      formOptions.error = (
        <div>
          Since your email domain does not match this organization's domain  <strong><em>{domain}</em></strong>, please <a style={{textDecoration: 'underline'}} className="error-msg-link" href="mailto:info@worldwidewomen.co">contact us</a> to facilitate the claiming or <a className="error-msg-link" href="mailto:info@worldwidewomen.co">removal</a> of your page.
        </div>
      );
      */
    }

    return {formOptions, formValue };
  }

  onFormChange = (formValue) => {
    let formState = this.getFormState(formValue);
    formState.formOptions.hasError = false;
    formState.formOptions.fields.email.hasError = false;
    this.setState({ ...formState });
  };

  extractDomain(url) {
    if (!url) return '';

    let tmp = url.split('/');
    tmp = tmp[url.indexOf('://') > -1 ? 2 : 0].split(':')[0];
    return (tmp.indexOf('www.') == 0) ? tmp.substring(4) : tmp;
  }

  emailDomainMatches = (email, domain) => {
    if(!isEmail(email) || !domain) {
      return false;
    }

    if (email.endsWith(domain)) {
      return true;
    }

    return false;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const value = this.refs.claimForm.getValue();

    if(value && !this.state.formOptions.hasError) {
      let newValue = Object.assign({}, value);
      newValue.is_non_profit = (value.profit_type == 'nonprofit')? true : false;
      delete newValue.profitType;
      this.props.doClaimOrganization(newValue);
    }
  };

  removeOnBoardingStep() {
    const { auth, organization } = this.props;
    const { user } = auth;

    if(user && user.on_boarding && user.on_boarding.steps.indexOf('claim') != -1) {
      let onboarding = removeOnBoardingStep(user.on_boarding, 'claim');
      this.props.doUpdateOnBoardingSteps(onboarding);
    }
  }

  checkRedirect = (props) => {
    const { auth, organization, organizationClaim } = props;
    const { user } = auth;

    if (auth.isLoading || organizationClaim.isLoading || organization.isLoading) {
      return
    }

    if (!this.isClaimable(props)) {
      if (user && user.organizationClaim && user.organizationClaim.organization == organization.db_id) {
        if (user.verified) {
          return props.push(`/organizations/${organization.db_id}`)
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.params.id != nextProps.params.id) {
      this.props.loadOrganization(nextProps.params.id);
    }

    const formState = this.getFormState();
    this.setState(formState);
    this.removeOnBoardingStep();
    this.checkRedirect(nextProps)
  }

  componentWillMount() {
    this.props.loadOrganization(this.props.params.id);
    const formState = this.getFormState();
    this.setState(formState);
    this.checkRedirect(this.props)
  }

  componentDidMount() {
    this.removeOnBoardingStep();
  }

  render() {

    const { auth, organization, organizationClaim } = this.props;
    const { user } = auth;
    const toOrgBtn = <Link className="button" to={`/organizations/${organization.db_id}`}>Go back</Link>
    const sendEmailBtn = <button onClick={() => { this.props.doSendVerificationEmail({claim_id: organizationClaim.id}); }} className="button button-primary">I did not receive it. Send Again!</button>
    let content = <span/>

    console.info("is claim =========>", this.isClaimable(this.props))
    console.info("org ===>", organization)
    console.info("org claim ===>", organizationClaim)

    console.info("auth ===>", auth)
    if (auth.isLoading || organizationClaim.isLoading || organization.isLoading) {
      return <span/>;
    }

    if (!this.isClaimable(this.props)) {
      if (user && user.organizationClaim && user.organizationClaim.organization == organization.db_id) {
        // logged in User has claimed this organization.
        if (user.verified) {
          content = <div style={{marginTop: "6rem", marginBottom: "6rem", textAlign:"center"}}>
            <h3>Coungratulation!</h3>
            <p><em>You have claimed <Link to={`/organizations/${organization.db_id}`}>{organization.name}</Link>.</em></p>
          </div>
        } else {
          content = <div style={{marginTop: "3rem", marginBottom: "6rem", textAlign:"center"}}>
            <h3>Please verify your email.</h3>
            <p> To complete the claim of your organization check your email inbox for your WorldWideWomen organization claim email and click the "Edit you organization" button to begin editing your organization page.</p>
            <p> {sendEmailBtn} </p>
          </div>
        }
      }
    } else {
        content = (
          <div className="organization-claimForm">
            <form onSubmit={this.handleSubmit}>
              <h4>One more step to claim {organization.name}</h4>
              <t.form.Form options={this.state.formOptions}
                          value={this.state.formValue}
                          ref="claimForm"
                          onChange={this.onFormChange}
                          type={OrganizationClaimSchema} />
              <button type="submit" onClick={this.handleSubmit} className="button button-primary">Submit Claim</button>
              &nbsp;
              <Link onClick={(e) => { this.removeOnBoardingStep(); }} to={`/organizations/${organization.db_id}`} className="button">Cancel</Link>
              <div className="organization-claimForm-footnote">
              <a href="mailto:info@worldwidewomen.co">Please remove this organization</a>
              <br /><br />

              * We invite all non-profit organizations to live on our website free of charge.
              <br />&nbsp;&nbsp;&nbsp;During our beta phase all "for profit" companies are also invited to list free of charge.
              </div>
            </form>
          </div>
        )

    }

    return (
      <div className="organization-apply">
        <div className="content-wrapper">{content}</div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  {
    push,
    loadOrganization,
    loadOrganizationClaim,
    doClaimOrganization,
    doUpdateOnBoardingSteps,
    doSendVerificationEmail
  }
)(OrganizationClaim);



// WEBPACK FOOTER //
// ./src/containers/OrganizationClaim.jsx